import React from 'react';
import { useUserStore } from '../../../stores';
import { TELEGRAM_INTEGRATION_BOT } from '../constants/constants';

const TelegramIntegration = () => {
  const { user } = useUserStore();
  const href = `${TELEGRAM_INTEGRATION_BOT}?start=user_id=${user.id}`;

  return (
    <>
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={
          'block cursor-pointer text-center w-full bg-gray-900 hover:bg-orange-500 transition text-white py-2 px-4 hover:border-orange-500 rounded-full disabled:bg-gray-300'
        }>
        Регистрация в tg-боте
      </a>

      <div className={'text-gray-700 my-2 text-xs'}>
        *Сначала зарегистрируйтесь в нашем Telegram-боте, нажав кнопку «Регистрация в tg-боте», а затем выберите «START BOT». После этого можно продолжить
        создание интеграции
      </div>
    </>
  );
};
export default TelegramIntegration;
